@if (isIE) {
  <div class="row">
    <article class="col-sm-12">
      <alert type="danger">
        <h4 class="alert-heading">Error!</h4>
        Browser not supported!
        <p>
          <br>
            <a href="https://www.google.com/chrome/" class="btn btn-sm btn-default"><strong>Download Chrome</strong></a>&nbsp;
            <a href="https://www.mozilla.org/firefox/" class="btn btn-sm btn-default"><strong>Download Firefox</strong></a>&nbsp;
            <a href="https://support.apple.com/downloads/#safari" class="btn btn-sm btn-default"><strong>Download Safari</strong></a>&nbsp;
            <a href="https://www.microsoft.com/edge" class="btn btn-sm btn-default"><strong>Download Edge</strong></a>
          </p>
        </alert>
      </article>
    </div>
  }

  @if (!isIE) {
    <router-outlet></router-outlet>
  }

  <ic-toast></ic-toast>
